module.exports = __webpack_public_path__ + "static/media/categorie.515cbb0b.svg";